import { makeStyles } from "../Utilities/ThemeHelper";
export const useStyles = makeStyles(theme => ({
  root: {
    color: "inherit"
  },
  circular: {
    display: "flex"
  },
  inner: {
    margin: "0 auto"
  },
  verticallyCenter: {
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    flexGrow: 1
  },
  animation: {
    height: props => props.size ? props.size : 200
  }
}));